import { render, staticRenderFns } from "./product_material_edit.vue?vue&type=template&id=68dd78dc&scoped=true"
import script from "./product_material_edit.vue?vue&type=script&lang=js"
export * from "./product_material_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68dd78dc",
  null
  
)

export default component.exports